/**
 * 按表格顺序贪心分配转移金额：前几条全额，末行不足时切分。
 * amounts 为带符号金额；按绝对值分配；返回每票要转的绝对值（>0）。
 */
export interface GlTransferAllocItem {
    invoiceId: string;
    /** 该票源科目金额（带符号） */
    amount: number;
    /** 分配到的转移绝对值；0 表示不转 */
    transferAbs: number;
    /** 是否末行切分（转出 < 票面绝对值） */
    split: boolean;
}

export function allocateTransferAmounts(
    rows: Array<{invoiceId: string; amount: number}>,
    targetAbs: number,
): GlTransferAllocItem[] {
    const result: GlTransferAllocItem[] = rows.map((r) => ({
        invoiceId: r.invoiceId,
        amount: r.amount,
        transferAbs: 0,
        split: false,
    }));
    if (!Number.isFinite(targetAbs) || targetAbs <= 0) return result;

    let remaining = Math.round(targetAbs * 100) / 100;
    for (const item of result) {
        if (remaining <= 1e-9) break;
        const rowAbs = Math.abs(Number(item.amount) || 0);
        if (rowAbs <= 1e-9) continue;
        const take = Math.min(rowAbs, remaining);
        const rounded = Math.round(take * 100) / 100;
        item.transferAbs = rounded;
        item.split = rounded + 1e-9 < rowAbs;
        remaining = Math.round((remaining - rounded) * 100) / 100;
    }
    return result;
}

/** 同符号校验：0 视为中性；非零须与已选同号 */
export function sameSignOrNeutral(a: number, b: number): boolean {
    if (a === 0 || b === 0) return true;
    return Math.sign(a) === Math.sign(b);
}
